import { IJsonSerializable } from '../util/interfaces'

export class SESSION_ERROR implements IJsonSerializable {

    // Properties

    public code: any[]
    public msg: any

    // Properties End


    // Ctor

    constructor(opObject: any = null) {
        this.fromJSON(opObject)
    }

    // Ctor End


    // IJsonSerializable Implementation
    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.code = opObj.Code
            this.msg = opObj.Msg
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            Code: this.code == undefined ? null : this.code,
            Msg: this.msg == undefined ? null : this.msg
        }
    }

    // IJsonSerializable Implementation End
}
